import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import './LogoutConfirmModal.css';

const LogoutConfirmModal = ({ open, onCancel, onConfirm }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onCancel?.();
    };
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onCancel]);

  if (!open) return null;

  return createPortal(
    <div
      className="logout-confirm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="logout-confirm-title"
      aria-describedby="logout-confirm-message"
      onClick={onCancel}
    >
      <div
        className="logout-confirm__panel"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="logout-confirm-title" className="logout-confirm__title">
          {TEXT_LABELS.LOGOUT_CONFIRM_TITLE}
        </h2>
        <p id="logout-confirm-message" className="logout-confirm__message">
          {TEXT_LABELS.LOGOUT_CONFIRM_MESSAGE}
        </p>
        <div className="logout-confirm__actions">
          <button
            type="button"
            className="logout-confirm__btn logout-confirm__btn--cancel"
            onClick={onCancel}
          >
            {TEXT_LABELS.LOGOUT_CONFIRM_CANCEL}
          </button>
          <button
            type="button"
            className="logout-confirm__btn logout-confirm__btn--confirm"
            onClick={onConfirm}
          >
            {TEXT_LABELS.LOGOUT_CONFIRM_ACTION}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

LogoutConfirmModal.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

LogoutConfirmModal.defaultProps = {
  open: false,
  onCancel: undefined,
  onConfirm: undefined,
};

export default LogoutConfirmModal;
